var app_markets_table = $('#app-markets-table');

if (app_markets_table.length) {
    function initializeMarketsTable() {
        var marketType = window.app_markets_table.attr('data-market-type');

        window.app_markets_table.DataTable({
            ajax: {
                url: '/markets/list/' + marketType,
                dataSrc: 'data'
            },
            columns: [
                {data: 'name'},
                {data: 'vendorCount'},
                {data: 'slug'}
            ],
            editable: false,
            destroy: true,
            pageLength: user_entries,
            "columnDefs": [
                {
                    "targets": 2,
                    "orderable": false,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        if (rowData.type === ''){
                            rowData.type = 'custom';
                        }
                        var html = '<div class="row text-center">';
                        console.log(rowData.slug);
                        html += '<div class="btn-group" role="group">' +
                            '<a href="/markets/' + rowData.type + '/' + rowData.slug + '" role="button" class="btn btn-success btn-sm">' +
                            '<i class="fa fa-pencil"></i> Edit' +
                            '</a>';

                        if(rowData.type === 'custom' && table_editable) {
                            html += '<a href="javascript:void(0)" onclick="deleteMarket(\'' + rowData.type + '\',\'' + rowData.slug + '\')" role="button" class="btn btn-danger btn-sm">' +
                                '<i class="fa fa-trash-o"></i> Delete' +
                                '</a></div>';
                        }

                        html += '</div>';
                        $(td).html(html);
                    }
                }]
        });
    }

    function deleteMarket(urlVar, slugData) {
        if (urlVar == '')
            urlVar = 'custom';
        $('#deleteMarketConfirmed').attr('data-url', urlVar);
        $('#deleteMarketConfirmed').attr('data-slug', slugData);
        $('#deleteMarketWarningModal').modal('show');
    }
    function deleteMarketConfirmed() {
       var urlVar =  $('#deleteMarketConfirmed').attr('data-url');
       var slugData = $('#deleteMarketConfirmed').attr('data-slug');

        show_loader();
        $.ajax({
            url: '/markets/' + urlVar + '/destroy',
            type: 'POST',
            data: {'_token': $('meta[name="csrf-token"]').attr('content'), 'market_slug': slugData},
            success: function (response) {
                global_notification('success', 'Market Deleted');
                initializeMarketsTable();
                $('#deleteMarketWarningModal').modal('hide');
                hide_loader();
            },
            error: function (xhr) {
                if (xhr.status === 422) {
                    global_notification('warning', xhr.responseJSON.message);
                } else {
                    ajax_error();
                    debug(xhr.responseText);
                }
                hide_loader();
            }
        });
    }

    initializeMarketsTable();
}
